import React from 'react';
import BaseValidator from 'services/validations/base-validator';

class PlayersQuantityValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {sportConfig} = this.dependencies;
        const stackedPlayersQuantity = this.getStackedPlayersQuantity();
        const lineupPlayersQuantity = sportConfig.getConfigProp('maxStackedPlayersInRandomTeamsStacking');

        if (stackedPlayersQuantity > lineupPlayersQuantity) {
            this.addError(`Max amount of stacked players is ${lineupPlayersQuantity}.`);
        }
    }

    private getStackedPlayersQuantity(): number {
        // @ts-ignore
        const {stacking} = this.dependencies;
        let quantity = stacking.getPlayersQuantityByGroupNumber(1);
        quantity += stacking.getPlayersQuantityByGroupNumber(2);
        return quantity;
    }
}

export default PlayersQuantityValidator;
